{
	"title": "Materiali disponibili",
	"showAllTitle": "Mostra tutti i materiali",
	"table": {
		"material": "Materiale",
		"invoicedQuantity": "Quantità fatturata",
		"remainingForTransfer": "Rimanente per la creazione della dichiarazione",
		"fetchError": "Impossibile recuperare i materiali",
		"noMaterials": {
			"title": "Nessun materiale disponibile",
			"description": "Al momento non hai materiali disponibili su {{productName}}. Contatta il tuo rappresentante commerciale per aggiungere il/i tuo/i contratto/i al tuo account."
		}
	}
}
